import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import suitcss from '../../../helpers/suitcss';
import FieldInput from '../../basics/form/FieldInput';
import FieldRadioGroup from '../../basics/form/FieldRadioGroup';
import FieldSelectbox from '../../basics/form/FieldSelectbox';
import FieldDate from '../../basics/form/FieldDate';
import FormSection from '../form/FormSection';
import FormHeader from '../form/FormHeader';
import Link from '../../basics/text/TextLink';
import Copy from '../../basics/text/TextCopy';
import { getIdentOptions } from '../../../helpers/identMethods';
import FieldAccordion from '../../basics/form/FieldAccordion';

class ActivationFormPersonalData extends PureComponent {

  constructor(props, context) {
    super(props, context);
    this.state = { isAddressExtraToggled: false };
    this.toggleAdressExtra = this.toggleAdressExtra.bind(this);
  }

  toggleAdressExtra() {
    this.setState({ isAddressExtraToggled: true });
  }

  renderFormPersonalData() {
    const { fieldMap, formValues, ui, params } = this.props;
    const { personalHeadline, personalCopy } = params;
    const { isAddressExtraToggled } = this.state;
    const isEmailDirty = !!formValues[fieldMap.eMail.name];
    const isPasswordDirty = !!formValues[fieldMap.password.name];
    return (<Fragment>
      <FormHeader
        headline={personalHeadline}
        copy={personalCopy}
        ui={ui}
        utilities={['col12', 'mlCol8']}
      />
      <div className={suitcss({ utilities: ['grid'] })}>
        <Field {...fieldMap.salutation} component={FieldRadioGroup} utilities={['col12']} withToolTip />
        <Field {...fieldMap.firstName} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        <Field {...fieldMap.lastName} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        <Field {...fieldMap.birthday} component={FieldDate} isDateGroup utilities={['col12', 'mlCol6']} withToolTip />
        <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        <Field {...fieldMap.addressStreet} component={FieldInput} utilities={['col12', 'mlCol4']} withToolTip />
        <Field {...fieldMap.addressNumber} component={FieldInput} utilities={['col12', 'mlCol2']} withToolTip />
        <Field {...fieldMap.addressZip} component={FieldInput} utilities={['col12', 'mlCol2']} withToolTip />
        <Field {...fieldMap.addressCity} component={FieldInput} utilities={['col12', 'mlCol4']} withToolTip />
        {!isAddressExtraToggled && (
          <div className={suitcss({ utilities: ['col12', 'mlCol6', 'marginTopAuto', 'alignRight'] })}>
            <Link element="button" utilities={['textSizeSmall']} onClick={this.toggleAdressExtra} withoutArrow >
              {ui.cfoAddressSecondLineAdd}
            </Link>
          </div>
        )}
        {!isAddressExtraToggled && (
          <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        )}
        {isAddressExtraToggled && (
          <Field {...fieldMap.addressExtra} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        )}
        {isAddressExtraToggled && (
          <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        )}
        <Field {...fieldMap.eMail} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        {isEmailDirty &&
          <Field {...fieldMap.eMailRepeat} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        }
        {!isEmailDirty &&
          <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        }
        <Field {...fieldMap.password} type="password" component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        {isPasswordDirty &&
          <Field {...fieldMap.passwordRepeat} type="password" component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        }
        {!isPasswordDirty &&
          <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        }
        {this.renderConsentText()}
      </div>
    </Fragment>);
  }

  renderIdentChoice() {
    const { fieldMap, countries, ui, identMethods, form, pplus } = this.props;
    const filteredIdentOptions = getIdentOptions(identMethods, ui, !!pplus);
    const identOptions = getIdentOptions(identMethods, ui);
    const filteredAllOptions = filteredIdentOptions.length === 0 && identOptions.length !== 0;

    return (<Fragment>
      <FormHeader
        headline={ui.identMethodSelection}
        copy={ui.identNationalityHint}
        utilities={['col12', 'mlCol8']}
      />
      <div className={suitcss({ utilities: ['grid'] })}>
        <Field
          {...fieldMap.idCardNationality}
          options={Object.values(countries).map(country => ({
            value: country.id,
            label: country.name,
          }))}
          component={FieldSelectbox}
          utilities={['col12', 'mlCol6']}
        />
        {!!filteredIdentOptions.length && filteredIdentOptions.map((option, index) => (
          <FieldAccordion
            formIdentifier={form}
            name={fieldMap.identMethod.name}
            label={option.label}
            value={option.value}
            key={index}
            utilities={['col12']}
            withToolTip
            validation={fieldMap.identMethod.validation}
          >
            <Field
              {...fieldMap.identityMedia}
              options={Object.values(option.availableIdentityMedia).map(media => ({
                value: media.key,
                label: media.name,
              }))}
              component={FieldRadioGroup}
              utilities={['col12']}
              withToolTip
              asStack
            />
          </FieldAccordion>
        ))}
        {!filteredIdentOptions.length &&
          <Copy utilities={['col12', 'colorError']} embedded raw>
            {filteredAllOptions ? ui.identMethodPplusUnavailable : ui.identMethodUnavailable}
          </Copy>
        }
      </div>
    </Fragment>);
  }

  renderConsentText() {
    return (<div className={suitcss({ utilities: ['grid', 'lCol12'] })}>
      <Copy raw size="small" utilities={['colorGray100']}>
        {this.props.consentText}
      </Copy>
    </div>);
  }

  render() {
    return (
      <FormSection className={suitcss({}, this)} >
        {this.renderFormPersonalData()}
        {this.renderIdentChoice()}
      </FormSection>
    );
  }
}

ActivationFormPersonalData.propTypes = {
  // form logic
  onError: PropTypes.func.isRequired,
  fieldMap: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
  params: PropTypes.shape({
    personalHeadline: PropTypes.string.isRequired,
    personalCopy: PropTypes.string.isRequired,
  }),
  ui: PropTypes.object.isRequired,
  countries: PropTypes.array.isRequired,
  identMethods: PropTypes.array.isRequired,
  form: PropTypes.string.isRequired,
  pplus: PropTypes.object,
  consentText: PropTypes.string,
};

export default ActivationFormPersonalData;
